import { AttributeMultiValueWrite } from './attributeMultiValueWrite';
import { Attribute } from 'src/app/shared/models/attributes/attribute';

import * as _ from 'lodash';
import { AttributeEntityType } from './attributeEntityType';
import { AttributeUiType } from './attributeUiType';

export class AttributeWrite {
  public value: string;
  public attributeDefinitionId: string;
  public attributeDefinitionValueListItemId: string;
  public values: AttributeMultiValueWrite[];
  public entityType: AttributeEntityType; // introduced to support processing of forms with mulitple entity types
  public uiType: AttributeUiType;

  constructor(
    value: string,
    attributeDefinitionId: string,
    attributeDefinitionValueListItemId: string,
    values: AttributeMultiValueWrite[] = null,
    entityType: AttributeEntityType = null,
    uiType: AttributeUiType = null
  ) {
    this.value = value;
    this.attributeDefinitionId = attributeDefinitionId;
    this.attributeDefinitionValueListItemId = attributeDefinitionValueListItemId;
    this.values = values;
    this.entityType = entityType;
    this.uiType = uiType;
  }

  hasValue(): boolean {
    return (
      !(_.isNil(this.value) || (typeof this.value === 'string' && this.value.trim() === '')) ||
      !(_.isNil(this.attributeDefinitionId) || this.attributeDefinitionId === '') ||
      (this.values && this.values.length > 0)
    );
  }

  containsSearchValue(searchValue: string) {
    return this.value.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
  }

  static parse(obj: any): AttributeWrite {
    let attribute = new AttributeWrite(
      obj.value,
      obj.attributeDefinitionId,
      obj.attributeDefinitionValueListItemId,
      obj.values,
      obj.entityType,
      obj.uiType
    );
    attribute.attributeDefinitionValueListItemId = obj.attributeDefinitionValueListItem
      ? obj.attributeDefinitionValueListItem.id
      : null;

    return attribute;
  }

  static fromDisparateAttributes(attributes: Array<Attribute>): Array<AttributeWrite> {
    if (!attributes) return Array<AttributeWrite>();

    const grouped = _.groupBy(attributes, 'attributeDefinitionId');
    const attributeWrites = _.map(grouped, function (attributes: Attribute[]) {
      return AttributeWrite.fromAttributes(attributes);
    });

    return _.reject(attributeWrites, function (attribute) {
      return _.isUndefined(attribute);
    });
  }

  static fromAttributes(attributes: Attribute[]): AttributeWrite {
    let firstAttribute = attributes[0];
    if (firstAttribute.isCheckboxType() || firstAttribute.isMultiSelectType()) {
      if (firstAttribute.valueList && firstAttribute.valueList.length > 0) {
        return AttributeWrite.parse({
          attributeDefinitionId: firstAttribute.attributeDefinitionId,
          values: _.map(firstAttribute.valueList, function (attribute) {
            return AttributeMultiValueWrite.fromAttributeValueTypeListItem(attribute);
          }),
          entityType: firstAttribute.entityType,
          uiType: firstAttribute.type,
        });
      }
    } else {
      if (firstAttribute.attributeDefinitionValueListItem) {
        return AttributeWrite.parse({
          attributeDefinitionId: firstAttribute.attributeDefinitionId,
          attributeDefinitionValueListItem: firstAttribute.attributeDefinitionValueListItem,
          entityType: firstAttribute.entityType,
          uiType: firstAttribute.type,
        });
      } else if (firstAttribute.hasValue()) {
        return AttributeWrite.parse({
          attributeDefinitionId: firstAttribute.attributeDefinitionId,
          value:
            typeof firstAttribute.value === 'string'
              ? firstAttribute.value.trim()
              : firstAttribute.value,
          entityType: firstAttribute.entityType,
          uiType: firstAttribute.type,
        });
      }
    }

    return undefined;
  }
}
